import * as React from 'react';

function SaleIcon(props) {
  return (
    <svg width={72} height={72} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M51.74 27.76l-1.535-1.535a3.191 3.191 0 01-.938-2.256v-2.197c0-3.537-2.878-6.412-6.416-6.412h-2.196a3.197 3.197 0 01-2.26-.94l-1.555-1.553c-2.516-2.493-6.587-2.493-9.08.02l-1.535 1.534a3.197 3.197 0 01-2.26.94H21.77c-3.539 0-6.416 2.874-6.416 6.41v2.174c0 .874-.341 1.684-.938 2.28l-1.556 1.558c-2.494 2.512-2.473 6.584.021 9.075l1.535 1.513c.597.617.938 1.427.938 2.282v2.192a6.423 6.423 0 006.416 6.416h2.195c.853 0 1.663.339 2.26.935l1.556 1.558a6.456 6.456 0 004.54 1.852 6.381 6.381 0 004.54-1.876l1.535-1.534a3.193 3.193 0 012.26-.935h2.195a6.423 6.423 0 006.416-6.416v-2.192c0-.855.34-1.664.938-2.261l1.513-1.513c.021-.021.042-.04.064-.064a6.338 6.338 0 001.833-4.538c0-1.705-.66-3.324-1.876-4.518z'
        fill='url(#prefix__paint0_linear_70_6799)'
      />
      <g filter='url(#prefix__filter0_bi_70_6799)'>
        <path
          d='M59.13 35.153l-1.534-1.534a3.191 3.191 0 01-.938-2.256v-2.197c0-3.537-2.877-6.412-6.416-6.412h-2.195a3.197 3.197 0 01-2.26-.94l-1.556-1.553c-2.515-2.493-6.586-2.493-9.08.02l-1.535 1.534a3.196 3.196 0 01-2.26.94h-2.195c-3.538 0-6.416 2.874-6.416 6.41v2.174c0 .874-.34 1.684-.938 2.28l-1.556 1.558c-2.494 2.512-2.472 6.584.022 9.075l1.534 1.513c.597.618.938 1.427.938 2.282v2.192a6.423 6.423 0 006.416 6.416h2.196c.852 0 1.662.339 2.26.935l1.555 1.558A6.456 6.456 0 0039.712 61a6.381 6.381 0 004.54-1.875l1.535-1.535a3.193 3.193 0 012.26-.935h2.195a6.423 6.423 0 006.416-6.416v-2.192c0-.855.341-1.664.938-2.261l1.514-1.513c.02-.021.042-.04.063-.064a6.338 6.338 0 001.834-4.538c0-1.705-.661-3.324-1.876-4.518z'
          fill='#72BF44'
          fillOpacity={0.5}
        />
      </g>
      <path
        d='M35.534 46.489c-.34.362-.81.554-1.321.554-.49 0-.96-.192-1.3-.554a1.877 1.877 0 010-2.642l10.956-10.953a1.857 1.857 0 012.622 0 1.88 1.88 0 010 2.645l-10.957 10.95zM45.19 47.043a1.865 1.865 0 01-1.875-1.875c0-1.021.83-1.854 1.875-1.854 1.024 0 1.855.833 1.855 1.854a1.86 1.86 0 01-1.855 1.875zM36.089 34.215a1.855 1.855 0 00-1.855-1.853c-1.023 0-1.876.83-1.876 1.853 0 1.047.853 1.876 1.876 1.876a1.859 1.859 0 001.855-1.876z'
        fill='#fff'
        fillOpacity={0.9}
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_70_6799'
          x1={11}
          y1={11}
          x2={48.16}
          y2={6.68}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#4FB84E' />
          <stop offset={1} stopColor='#2A8640' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_70_6799'
          x={14.392}
          y={14.394}
          width={50.615}
          height={50.605}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={2} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_70_6799' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_70_6799' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.2} dy={0.1} />
          <feGaussianBlur stdDeviation={0.5} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_70_6799' />
        </filter>
      </defs>
    </svg>
  );
}

export default SaleIcon;
